<template>
  <div class="screen-tab-filtering-status-bar">
    <div>
      Filtering by
      <!-- Filters, their values, each joined by & symbol -->
      <span v-for="(props, idx) in filtersToShow" :key="props.label">
        <!-- Filter label -->
        <span class="mr-1">{{ props.label }}</span>

        <!-- Filter values (as chips) -->
        <template v-for="(value, valIdx) in props.values">
          <v-chip
            :key="valIdx"
            class="px-2 mr-1"
            :class="props.chipTextColor"
            :color="props.chipColor"
            small
          >
            {{ value }}
          </v-chip>
        </template>

        <!-- & symbol if not the last filter -->
        <template v-if="idx !== filtersToShow.length - 1">
          &amp;
        </template>
      </span>
    </div>

    <!-- Clear button -->
    <v-btn
      fab
      width="24"
      height="24"
      elevation="0"
      color="grey lighten-2"
      @click="$emit('clear')"
    >
      <v-icon color="grey" small>close</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { Review, ReferenceFilteringInputDto } from '@/models';

const FILTER_TO_PROPS = {
  hasTag: {
    label: 'Tags',
    chipColor: 'primary',
    chipTextColor: 'white--text',
    valueTransform: (tagIds, review) => {
      return tagIds.map((tagId) => {
        const tag = review.tags.find((tag) => tag.id === tagId);
        return tag.label;
      });
    },
  },
  hasKeyword: {
    label: 'Keywords',
  },
  hasAuthor: {
    label: 'Authors',
  },
  hasPlacePublished: {
    label: 'Place Published',
  },
};

export default {
  name: 'ScreenTabFilteringStatusBar',
  props: {
    review: {
      type: Review,
      required: true,
    },
    filteringInput: {
      type: ReferenceFilteringInputDto,
      required: true,
    },
  },
  emits: ['clear'],
  computed: {
    filtersToShow() {
      const filters = Object.entries(FILTER_TO_PROPS).map(
        ([key, props]) => {
          let values = this.filteringInput[key];
          if (!values) return null;

          if (props.valueTransform) {
            values = props.valueTransform(values, this.review);
          }

          return {
            ...props,
            chipColor: props.chipColor || 'grey lighten-2',
            chipTextColor:
              props.chipTextColor || 'grey--text text--darken-2',
            values,
          };
        }
      );

      return filters.filter(Boolean);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~vuetify/src/styles/main.sass';

.screen-tab-filtering-status-bar {
  @extend .d-flex, .align-center, .pl-13, .pr-3;
  gap: 12px;

  background-color: map-get($grey, 'lighten-5');
  border-bottom: 1px solid map-get($grey, 'lighten-2');
  height: $screen-tab-filtering-status-bar-height;

  color: map-get($grey, 'base');
  font-size: 12px;
  font-weight: 700;
}
</style>
